import { useState, useEffect } from "react";

export default function AutoSaveIndicator({ lastSaved, isSaving }) {
  const [timeAgo, setTimeAgo] = useState("");
  
  useEffect(() => {
    if (!lastSaved) return;
    
    const updateTimeAgo = () => {
      const seconds = Math.floor((Date.now() - lastSaved) / 1000);
      if (seconds < 5) setTimeAgo("just now");
      else if (seconds < 60) setTimeAgo(`${seconds}s ago`);
      else if (seconds < 3600) setTimeAgo(`${Math.floor(seconds / 60)}m ago`);
      else setTimeAgo("over 1h ago");
    };
    
    updateTimeAgo();
    const interval = setInterval(updateTimeAgo, 1000);
    return () => clearInterval(interval);
  }, [lastSaved]);
  
  if (isSaving) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-500">
        <div className="w-1 h-1 rounded-full bg-indigo-500 animate-pulse"></div>
        <span>Saving...</span>
      </div>
    );
  }
  
  if (lastSaved) {
    return (
      <div className="flex items-center gap-2 text-xs text-slate-500">
        <div className="w-1 h-1 rounded-full bg-emerald-500"></div>
        <span>Saved {timeAgo}</span>
      </div>
    );
  }
  
  return (
    <div className="flex items-center gap-2 text-xs text-slate-400">
      <div className="w-1 h-1 rounded-full bg-slate-300"></div>
      <span>Not saved</span>
    </div>
  );
}
